import { useNavigate } from "react-router-dom";

import { useAppSelector } from "src/redux/store";
import Layout from "src/router/AuthenticatedRouter/Layout";
import useAtsPagination from "src/hooks/useAtsPagination";
import { AtsJob } from "src/types/merge_ats";
import { AtsPaginationParams } from "src/network/company_ats/type";
import { getCompanyAtsJobs } from "src/network/company_ats";
import PaginatedDiv from "src/components/PaginatedDiv";
import Table from "src/components/Tables/Table";
import Button from "src/components/Button";
import LoaderPage from "src/components/Loader/LoaderPage";
import { dateFormat1 } from "src/utils/dates/formats";
import StatusTag from "../Components/StatusTag";
import Import from "src/assets/images/generic/import.png";
import { useState } from "react";
import ImportJobModal from "../Components/ImportJobModal";

const AtsJobsPage = () => {
  const navigate = useNavigate();
  const [importing, setImporting] = useState<AtsJob>();
  const ats = useAppSelector((r) => r.client.client?.Company.Ats);
  if (!ats) return null;
  const { data, done, fetching, fetch } = useAtsPagination<AtsJob, AtsPaginationParams>({
    fetchPage: getCompanyAtsJobs,
    page_size: 10
  });

  return (
    <Layout
      className="!overflow-hidden flex flex-col"
      title={
        <div className="flex items-center gap-6">
          <p>{ats.integration}</p>
          <p className="rounded-lg border-[1px] text-success border-success p-2 font-semibold text-sm">
            Connected
          </p>
        </div>
      }
    >
      <Button shapeVariant={2} className="!cursor-text mb-9 !w-fit rounded-full">
        List of Jobs
      </Button>
      {!data && <LoaderPage />}
      {data?.length === 0 && (
        <div className="w-full flex flex-col items-center justify-center pt-[100px] gap-6 overflow-scroll ">
          <img src={Import} className="w-[290px] h-[240px]" />
          <p className="text-center font-semibold leading-9 w-[480px]">
            We're currently importing data from the ATS. Please check back shortly!
          </p>
        </div>
      )}
      {!!data?.length && (
        <PaginatedDiv
          className="!h-auto flex-1 "
          onLimit={fetch}
          loading={fetching}
          // Hardcoded to make this component work with cursor pagination
          count={done ? 0 : 1000}
          currentCount={10}
        >
          <Table
            data={data}
            heads={["Job Title", "Status", "Date Created", "Action"]}
            row={(j: AtsJob) => {
              const { name, createdAt, _imported } = j;
              return [
                <p className=" overflow-hidden text-ellipsis whitespace-nowrap ">{name}</p>,
                <StatusTag job={j} />,
                <p className="w-[107px] overflow-hidden text-ellipsis">{dateFormat1(createdAt)}</p>,

                <div className="flex gap-5">
                  <Button
                    disabled={!!_imported}
                    onClick={() => setImporting(j)}
                    shapeVariant={2}
                    variant="white_blue"
                  >
                    {_imported ? "Imported" : "Import"}
                  </Button>
                  <Button
                    onClick={() => navigate("/ats/job/" + j.id)}
                    shapeVariant={2}
                    className=""
                  >
                    View Job
                  </Button>
                </div>
              ];
            }}
          />
        </PaginatedDiv>
      )}
      {/* Modals */}
      {importing && (
        <ImportJobModal open={true} onClose={() => setImporting(undefined)} job={importing} />
      )}
    </Layout>
  );
};

export default AtsJobsPage;
